import { ResponseService } from './../services/response.service';
import { FormService } from './../services/form.service';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { LocalStorageService } from './../services/local-storage.service';
import { CompanyService } from './../services/company.service';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { PhoneService } from './../services/phone.service';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
})
export class EditCompanyComponent implements OnInit {
  private phoneCodes;

  companyForm: FormGroup;
  newClientForm: FormGroup;
  company = {};
  companyLoading: Boolean = true;
  canEdit = true;
  isOwner = true;
  users;

  constructor(
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    private apiService: ApiService,
    private router: Router,
    private notificationsService: NotificationsService,
    private formService: FormService,
    private responseService: ResponseService,
    private phoneService: PhoneService

  ) {
    const controls = {
      name: new FormControl({value: '', disabled: true}),
      nip: new FormControl({ value: '', disabled: true }),
      street: new FormControl(''),
      country_id: new FormControl(''),
      street_hn: new FormControl(''),
      street_ln: new FormControl(''),
      postal_code: new FormControl(''),
      city: new FormControl('')
    };

    const validators = {
      name: [Validators.required],
      nip: [Validators.required, CustomDSValidators.nip],
      street: [Validators.required],
      country_id: [Validators.required],
      street_hn: [Validators.required],
      street_ln: [],
      postal_code: [Validators.required, CustomDSValidators.polishPostalCode],
      city: [Validators.required]
    };

    this.companyForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {
    this.phoneCodes = this.phoneService.getCountryCodes();

    let emailField = new FormControl('', [Validators.required, CustomValidators.email]);
    let isOwnerField = new FormControl('', []);
    let canEditField = new FormControl('', []);
    let cc_phone_notification = new FormControl('', [Validators.required]);
    let phone_notification = new FormControl('', [Validators.required, CustomDSValidators.internationalPhoneNumber(cc_phone_notification)]);
    let cc_phone_verification = new FormControl('', [Validators.required]);
    let phone_verification = new FormControl('', [Validators.required, CustomDSValidators.internationalPhoneNumber(cc_phone_verification)]);
    this.newClientForm = new FormGroup({
      email: emailField,
      canEdit: canEditField,
      isOwner: isOwnerField,
      cc_phone_notification: cc_phone_notification,
      phone_notification: phone_notification,
      cc_phone_verification: cc_phone_verification,
      phone_verification: phone_verification
    });

    this.companyService.getCompanyData(this.localStorageService.get('company')).subscribe(
      (company) => {
        delete (company['id']);
        delete (company['access']);
        delete (company['owner']);
        delete (company['contracts']);
        delete (company['users']);
        this.canEdit = company['canEdit'];
        this.isOwner = company['isOwner'];

        delete (company['canEdit']);
        delete (company['isOwner']);
        this.companyForm.setValue(company);
        if (!this.canEdit) {
          this.companyForm.disable();
        }
        this.companyLoading = false;
      },
      (error) => {
        this.notificationsService.error('Ups', 'Błąd podczas danych firmy');
      }
    );
    this.loadCompanyClients();
  }

  loadCompanyClients() { 
    this.apiService.get('/company/' + this.localStorageService.get('company') + '/client').subscribe(
      (response) => {
        this.users = this.responseService.success(false, response, 'clients');
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

  editCompany() {
    this.apiService.put('/company/' + this.localStorageService.get('company'), this.companyForm.value).subscribe(
      (response) => {
        const company = this.responseService.success(true, response, 'company', 'edit');
        this.router.navigateByUrl('/panel');
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

  addClient() {
    this.apiService.post('/company/' + this.localStorageService.get('company') + '/client', this.newClientForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response);
        //this.router.navigateByUrl('/panel');
      },
      (error) => {
        this.responseService.error(error);
      }
    )
    this.loadCompanyClients();
  }

  toggleMarketing(clientUuid: String) {
    this.apiService.post('/company/' + this.localStorageService.get('company') + '/client/' + clientUuid + '/marketing/toggle').subscribe(
      (response) => {
        this.users = this.responseService.success(true, response, 'clients');
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

  toggleTechnical(clientUuid: String) {
    this.apiService.post('/company/' + this.localStorageService.get('company') + '/client/' + clientUuid + '/technical/toggle').subscribe(
      (response) => {
        this.users = this.responseService.success(true, response, 'clients');
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

  togglePayments(clientUuid: String) {
    this.apiService.post('/company/' + this.localStorageService.get('company') + '/client/' + clientUuid + '/payments/toggle').subscribe(
      (response) => {
        this.users = this.responseService.success(true, response, 'clients');
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/company-view/edit-company.component.ts